<template>
    <div>
    <div v-if="!internalLoading">
        <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
            <div slot="header"><i class="icon-note"></i> Lead Detail</div>
        
                <b-card-body>
                    <div v-if="loading == false">
                        <b-row>
                            <b-col sm="3">
                            <b-form-group label-for="lead_code" label="Lead Code">
                                <b-form-input
                                id="lead_code"
                                type="text"
                                v-model="leadForm.lead_code"
                                readonly
                                placeholder="Lead Code"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="3">
                            <b-form-group label-for="name" label="Nama Konsumen">
                                <b-form-input
                                id="name"
                                type="text"
                                v-model="leadForm.name"
                                readonly
                                placeholder="Nama Konsumen"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="owner_name" label="Nama Pemilik">
                                <b-form-input
                                id="owner_name"
                                type="text"
                                v-model="leadForm.owner_name"
                                readonly
                                placeholder="Nama Pemilik"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="store_keeper" label="Penjaga Toko">
                                <b-form-input
                                id="store_keeper"
                                type="text"
                                v-model="leadForm.store_keeper"
                                readonly
                                placeholder="Penjaga Toko"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="name" label="Nama Konsumen">
                                <b-form-input
                                id="name"
                                type="text"
                                v-model="leadForm.name"
                                readonly
                                placeholder="Nama Konsumen"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="3">
                            <b-form-group label-for="province" label="Provinsi">
                                <b-form-input
                                id="province"
                                type="text"
                                v-model="leadForm.province_name"
                                readonly
                                placeholder="Provinsi"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="regencies" label="Kota / Kabupaten">
                                <b-form-input
                                id="regencies"
                                type="text"
                                v-model="leadForm.regencies_name"
                                readonly
                                placeholder="Kota / Kabupaten"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="district" label="Kecamatan">
                                <b-form-input
                                id="district"
                                type="text"
                                v-model="leadForm.district_name"
                                readonly
                                placeholder="Kecamatan"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="villages" label="Kelurahan">
                                <b-form-input
                                id="villages"
                                type="text"
                                v-model="leadForm.villages_name"
                                readonly
                                placeholder="Kelurahan"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="3">
                            <b-form-group label-for="name" label="Handphone">
                                <b-form-input
                                id="handphone"
                                type="text"
                                v-model="leadForm.handphone"
                                readonly
                                placeholder="Handphone"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="handphone2" label="Handphone 2">
                                <b-form-input
                                id="handphone2"
                                type="text"
                                v-model="leadForm.handphone2"
                                readonly
                                placeholder="Handphone 2"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="store_keeper" label="Handphone 3">
                                <b-form-input
                                id="handphone3"
                                type="text"
                                v-model="leadForm.handphone3"
                                readonly
                                placeholder="Handphone 3"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="3">
                            <b-form-group label-for="address" label="Alamat">
                                <b-form-textarea
                                id="address"
                                :rows="3"
                                :max-rows="6"
                                v-model="leadForm.address"
                                readonly
                                ></b-form-textarea>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="address_ktp" label="Alamat KTP">
                                <b-form-textarea
                                id="address_ktp"
                                :rows="3"
                                :max-rows="6"
                                v-model="leadForm.address_ktp"
                                readonly
                                ></b-form-textarea>
                            </b-form-group>
                            </b-col>
                            <b-col sm="6">
                            <b-form-group label-for="name" label="Lokasi Toko">
                                <GmapMap
                                v-if="myLocation != null"
                                :center="myLocation"
                                :zoom="10"
                                map-type-id="terrain"
                                style="height: 500px"
                                >
                                <GmapMarker
                                    :key="0"
                                    :title="'asd'"
                                    :position="myLocation"
                                >
                                    <GmapInfoWindow
                                    :options="{ maxWidth: 150 }"
                                    :position="myLocation"
                                    :opened="true"
                                    >
                                    <div>Lokasi Toko</div>
                                    </GmapInfoWindow>
                                </GmapMarker>
                                </GmapMap>
                            </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col lg="3">
                            <b-form-group
                                label-for="street_store_picture"
                                label="Foto Jalan Depan Toko"
                            >
                                <b-img
                                :src="urlAssets + leadForm.street_store_picture"
                                :thumbnail="true"
                                ></b-img>
                            </b-form-group>
                            </b-col>
                            <b-col lg="3">
                            <b-form-group
                                label-for="front_store_picture"
                                label="Foto Depan Toko"
                            >
                                <b-img
                                :src="urlAssets + leadForm.front_store_picture"
                                :thumbnail="true"
                                ></b-img>
                            </b-form-group>
                            </b-col>
                            <b-col lg="3">
                            <b-form-group
                                label-for="right_store_picture"
                                label="Foto Kanan Toko"
                            >
                                <b-img
                                :src="urlAssets + leadForm.right_store_picture"
                                :thumbnail="true"
                                ></b-img>
                            </b-form-group>
                            </b-col>
                            <b-col lg="3">
                            <b-form-group
                                label-for="left_store_picture"
                                label="Foto Kiri Toko"
                            >
                                <b-img
                                :src="urlAssets + leadForm.left_store_picture"
                                :thumbnail="true"
                                ></b-img>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="3">
                            <b-form-group
                                label-for="selfie_employee"
                                label="Selfie Depan Toko"
                            >
                                <b-img
                                :src="urlAssets + leadForm.selfie_employee"
                                :thumbnail="true"
                                ></b-img>
                            </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group
                                    label-for="supporting_image"
                                    label="Foto Pendukung"
                                >
                                    <b-img
                                    :src="urlAssets + leadForm.supporting_image"
                                    :thumbnail="true"
                                    ></b-img>
                                </b-form-group>
                                </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="inserted_by" label="Di input oleh">
                                <b-form-input
                                id="inserted_by"
                                type="text"
                                v-model="leadForm.employee_name"
                                readonly
                                placeholder="Di input oleh"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                            <b-form-group label-for="date_inserted" label="Tanggal Input">
                                <b-form-input
                                id="date_inserted"
                                type="text"
                                v-model="leadForm.date_insert_human"
                                readonly
                                placeholder="Tanggal Input"
                                ></b-form-input>
                            </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="3">
                                <b-form-group label-for="description" label="Deskripsi">
                                    <b-form-textarea
                                    id="description"
                                    :rows="3"
                                    :max-rows="6"
                                    v-model="leadForm.description"
                                    readonly
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <loading></loading>
                    </div>

                    <div slot="footer" class="text-right">
                        <b-button type="button" size="sm" variant="danger" @click="back">
                            <i class="fa fa-undo"></i> Back </b-button
                        >&nbsp;
                        <b-button type="button" size="sm" variant="primary" v-if="flag==1 && leadForm.customer_id == null" @click="convertToCustomer">
                            <i class="fa fa-save"></i> Convert to Grouping Outlet
                        </b-button>
                    </div>
                </b-card-body>

        </b-card>

        <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
            <b-tabs>
            <b-tab title="Questionnaire" active>
                <tab-quesioner 
                    :key="uniqueId(leadForm.lead_code)" v-if="leadForm.lead_code" 
                    :id="id" 
                    :loading="loading"
                    :questioner="questioner"> </tab-quesioner>
            </b-tab>
            </b-tabs>
        </b-card>
    </div>
    <loading v-else></loading>
</div>
</template>


<script>
    import axios from "axios";
    import * as moment from "moment";
    import loading from "@/templates/Loading.vue";
    import tabQuesioner from "@/views/leads/tabs/Questionnaire";
    import _ from "lodash";

    export default {
      name: "leads-detail",
      inheritAttrs: false,
      components: { loading, tabQuesioner },
      props: {
        leadForm: {
            type: [Array, Object],
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false
        },
        myLocation: {
            type: [Array, Object],
            default: null
        },
        questioner: {
            type: [Array, Object],
            default: () => [],
        },
        flag: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
    },
  data() {
    return {
      urlAssets: "https://storage.googleapis.com/mbsstorage/",
      selectedAttachmentFile: null,
      internalLoading: this.loading
    };
  },
  methods: {
    back: function () {
         this.$router.go(-1);
        },
    uniqueId: function (param = "") {
        return _.uniqueId(param);
        },
    convertToCustomer: function(){
        //evt.preventDefault();
        if (confirm("Apakah anda ingin mengkonversi leads ini menjadi konsumen baru ?")) {
            this.internalLoading = true;
          let customer = this.leadForm;
          this.axios
            .post("web/leads/convertion-to-customer", customer)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Konsumen",
                  message: response.data.message
                });
               this.internalLoading = false;
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              window.location.reload();
            });
        }
    }
}
}
</script>